import React from 'react';
import { useTranslation } from 'react-i18next';
import UnderConstruction from '../../component/ui/Common/UnderConstruction';
import styles from './MHAStatus.module.scss';

const MHAStatus = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.mhaPage}>
      <div className="page-title p-16">{t('pageTitle.mhaStatus')}</div>
      
      {/* 실제 페이지 콘텐츠 - 배경으로 보임 */}
      <div className={styles.mhaContent}>
        <h2>MHA Status Monitor</h2>
        <p>이 페이지에서는 MySQL High Availability 상태를 모니터링하고 관리할 수 있습니다.</p>
        
        {/* 더미 콘텐츠 */}
        <div className={styles.statsContainer}>
          <div className={styles.statCard}>
            <h3>Replication Status</h3>
            <div className={styles.statValue}>- / -</div>
          </div>
          <div className={styles.statCard}>
            <h3>Master/Slave</h3>
            <div className={styles.statValue}>준비중</div>
          </div>
          <div className={styles.statCard}>
            <h3>Lag Time</h3>
            <div className={styles.statValue}>- sec</div>
          </div>
        </div>
      </div>
      
      {/* 공사중 표시 오버레이 */}
      <UnderConstruction />
    </div>
  );
};

export default MHAStatus;
